import { TeamListDTO } from '../team/team-list.dto';
import { QualificationListDTO } from '../qualification/qualification-list.dto';
import { CollectiveAgreementListDTO } from '../collective-agreement/collective-agreement-list.dto';
import { TenantConnectionDTO } from '../tenant/tenant-connection.dto';
import { AbilityListDTO } from '../ability/ability-list.dto';

export class UserDTO {

    id: string;

    firstName: string;

    lastName: string;

    image: string;

    email: string;

    phone: string;

    cellPhone: string;

    socialSecurityNumber: string;

    twofactor: boolean;

    passwordStrength: number;

    passwordChanged: Date;

    enforcePasswordChange: boolean;

    enforceTwofactor: boolean;

    tenants: Array<TenantConnectionDTO>;

    teams: Array<TeamListDTO>;

    qualifications: Array<QualificationListDTO>;

    collectiveAgreement: CollectiveAgreementListDTO;

    abilities: Array<AbilityListDTO>;

    createdBy: string;

    updatedBy: string;

    createdAt: Date;

    updatedAt: Date;

}
